// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m915vq{overflow-y:hidden}\n._1bto1l2s{text-overflow:ellipsis}\n._1e0ccj1k{display:-webkit-box}\n._1nmz1hna{word-break:break-word}\n._1reo15vq{overflow-x:hidden}\n._1yyjcs5v{-webkit-line-clamp:2}\n._1yyjkb7n{-webkit-line-clamp:1}\n._sudp1e54{-webkit-box-orient:vertical}\n@supports not (-webkit-line-clamp:1){._102k8vuz{max-height:56px}._102kckbl{max-height:3pc}}", ""]);
// Exports
module.exports = exports;
